import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ArrowLeftIcon from "../components/icon/arrowLeftIcon";
import ArrowRightIcon from "../components/icon/arrowRightIcon";
import CloseIcon from "../components/icon/closeIcon";
import { Image } from "../components/common/image";
import { useNavigate, useParams } from "react-router-dom";
import { getComapanyContractImageList } from "../API/AppRepository";
import CustomButton from "../components/common/customButton";
const Wrapper = styled.div`
  width: 100vw;
  height: 94vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
`;

const HeaderArea = styled.div`
  width: 100%;
  height: 8vw;
  margin-top: 2vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TopArea = styled.div`
  width: 90%;
  height: 6vh;
  display: flex;
  /* outline: 1px solid green; */
  justify-content: space-around;
  align-items: center;
`;

const ImageContainer = styled.div`
  width: 90vw;
  height: 127vw;
  display: flex;
  /* outline: 2px solid red; */
  justify-content: space-around;
  outline: 0.2vw solid #d8d8d8;
  border-radius: 1.3vw;
  align-items: center;
  background-color: white;
`;

const ImageBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #ffffff; */
  border-radius: 1vw;
  width: 96%;
  height: 96%;
  /* outline: 1px solid red; */
`;

const StyledImage = styled(Image)`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

const LeftArea = styled.div`
  height: 100%;
  width: 35%;
  /* outline: 1px solid red; */
  display: flex;
  align-items: center;
`;

const MidArea = styled.div`
  width: 30%;
  /* outline: 1px solid red; */
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const RightArea = styled.div`
  height: 100%;
  /* outline: 1px solid red; */
  width: 35%;
  display: flex;
  justify-content: end;
  align-items: center;
`;
const CloseBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  &&:hover {
    cursor: pointer;
  }
`;
const NumBox = styled.div`
  width: 10vw;
  height: 5vw;
  background-color: #e7e7e7;
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.4vw;
  font-weight: 600;
`;
const PrevBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;
const NextBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;

export default function EnterpriseContractDetail() {
  const cmCd = useParams().id;
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [prevBoxActive, setPrevBoxActive] = useState<boolean>(false);
  const [nextBoxActive, setNextBoxActive] = useState<boolean>(true);
  const [imageList, setImageList] = useState<[]>([]);
  const maxIndex = imageList.length;

  useEffect(() => {
    const fetchCompanyContractImageList = async () => {
      if (cmCd) {
        const list = await getComapanyContractImageList(cmCd);
        setImageList(list);
      }
    };
    fetchCompanyContractImageList();
  }, []);

  useEffect(() => {
    if (currentPage <= 1) {
      setPrevBoxActive(false);
      setNextBoxActive(true);
    } else {
      setPrevBoxActive(true);
      if (currentPage >= maxIndex) {
        setNextBoxActive(false);
      } else {
        setNextBoxActive(true);
      }
    }
  }, [currentPage]);

  const clickPrevPage = (e: any) => {
    if (currentPage <= 1) {
      return;
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const clickNextPage = (e: any) => {
    if (currentPage >= maxIndex) {
      return;
    }
    setCurrentPage(currentPage + 1);
  };

  const openContractImage = (path: string) => {
    window.open(`https://homenmove.net/${path}`);
  };

  const onClose = () => {
    navigate(`/enterpriseContractList`);
    return;
  };

  return (
    <>
      <Wrapper>
        <HeaderArea>
          <TopArea>
            <LeftArea></LeftArea>
            <MidArea>
              <PrevBox $isActivate={prevBoxActive}>
                <ArrowLeftIcon
                  onClick={(e: any) => clickPrevPage(e)}
                  width={"4.2vw"}
                  height={"4.2vw"}
                  fill={"white"}
                />
              </PrevBox>
              <NumBox>
                {currentPage}/{maxIndex}
              </NumBox>
              <NextBox $isActivate={nextBoxActive}>
                <ArrowRightIcon
                  onClick={(e: any) => clickNextPage(e)}
                  width={"4.2vw"}
                  height={"4.2vw"}
                  fill={"white"}
                />
              </NextBox>
            </MidArea>
            <RightArea>
              <CustomButton
                onClick={onClose}
                width="10vw"
                height="6vw"
                text={`목록으로`}
                size="2vw"
              ></CustomButton>
            </RightArea>
          </TopArea>
        </HeaderArea>
        <ImageContainer>
          <ImageBox>
            {imageList.map((item: any, index: number) => {
              if (index + 1 === currentPage) {
                return (
                  <StyledImage
                    onClick={(e: any) => openContractImage(item.path)}
                    src={`https://homenmove.net/${item.path}`}
                    width={"100%"}
                    height={"100%"}
                    // height={"100%"}
                    key={index}
                  ></StyledImage>
                );
              }
            })}
          </ImageBox>
          {/* {currentPage === 1 ? <div>1페이지</div> : <div>2페이지</div>} */}
        </ImageContainer>
      </Wrapper>
    </>
  );
}
